import * as React from 'react';
export const chevronUpSvg = React.forwardRef(function chevronUpSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.381 2.381a.875.875 0 0 1 1.238 0l5 5A.875.875 0 0 1 10.38 8.62L6 4.237 1.619 8.62A.875.875 0 1 1 .38 7.38l5-5Z',
    }),
  );
});
chevronUpSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronUp = {
  category: 'icon',
  colorable: true,
  name: 'chevronUp',
  svg: chevronUpSvg,
};
